module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module5_Drink2_Elderflower-584d75023b295f48430aa56961d7811c.png";